import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Flame } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="fixed top-0 left-0 right-0 z-[60] h-9 bg-gradient-to-r from-combo-green via-combo-green to-combo-navy text-white shadow-md" data-id="element-20">
      <a href="#kits" className="h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-2 sm:gap-3 group" data-id="element-21">
        <motion.div animate={{
        rotate: [0, 15, -15, 0]
      }} transition={{
        duration: 1.5,
        repeat: Infinity
      }} className="hidden sm:block" data-id="element-22">
          <Flame className="w-3.5 h-3.5 text-yellow-300" data-id="element-23" />
        </motion.div>
        <span className="text-[11px] sm:text-xs font-bold tracking-wide text-center" data-id="element-24">
          <span className="hidden sm:inline" data-id="element-25">
            🎁 9 kits al 50% OFF te esperan más abajo —{' '}
          </span>
          <span className="sm:hidden" data-id="element-26">🎁 9 kits al 50% OFF — </span>
          <span className="underline decoration-yellow-300 underline-offset-2 group-hover:decoration-2" data-id="element-27">
            scrolleá para verlos todos
          </span>
        </span>
        <motion.div animate={{
        y: [0, 3, 0]
      }} transition={{
        duration: 1.2,
        repeat: Infinity
      }} data-id="element-28">
          <ArrowDown className="w-3.5 h-3.5 text-yellow-300" data-id="element-29" />
        </motion.div>
      </a>
    </div>;
}